import * as THREE from 'three/webgpu'

// Glowing cyberpunk toy. Smoothly moves to target, bobs, rotates.
// Cats with high playfulness will target this.position.
export default class Ball {
  constructor({ scene }) {
    this.scene = scene

    const geo = new THREE.SphereGeometry(1.5, 20, 14)
    const mat = new THREE.MeshStandardMaterial({
      color: 0xff7a1a,
      emissive: 0xff4a00,
      emissiveIntensity: 1.4,
      roughness: 0.45,
      metalness: 0.15,
    })
    this.mesh = new THREE.Mesh(geo, mat)
    this.mesh.castShadow = true
    // Start in the camera's center-bias area so it's visible immediately
    this.mesh.position.set(0, 1.8, -6)
    this.targetPos = this.mesh.position.clone()
    this._t = 0

    this.scene.add(this.mesh)
  }

  get position() { return this.mesh.position }

  // Free placement — user can toss the ball anywhere
  placeAt(point) {
    this.targetPos.set(point.x, 1.8, point.z)
  }

  update(dt) {
    this._t += dt
    const alpha = 1 - Math.exp(-7 * dt)
    this.mesh.position.x = THREE.MathUtils.lerp(this.mesh.position.x, this.targetPos.x, alpha)
    this.mesh.position.z = THREE.MathUtils.lerp(this.mesh.position.z, this.targetPos.z, alpha)
    this.mesh.position.y = this.targetPos.y + Math.sin(this._t * 2.8) * 0.25
    this.mesh.rotation.y += dt * 1.3
    this.mesh.rotation.x += dt * 0.6
  }
}
